import React from 'react';
import styled from 'styled-components';
import { useChat } from '../../contexts/ChatProvider';
import { regexForCodeblocks } from '../../utils/message';

export const Content = styled.div`
  text-align: left;
  vertical-align: text-top;
  font-size: 14px;
  align-self: flex-start;
  line-height: auto;
  color: ${({ color }) => color || '#000000'};
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  position: relative;
  box-sizing: border-box;
  word-wrap: break-word;
  width: 100%;
  max-width: ${({isFullScreen}) => isFullScreen ? "800px" : "272px"} ;

  a {
      color: ${({ linkColor }) => linkColor || 'blue'};
  }
  .div1 {
    width: 100%;
  }
  .pre1 {
    background-color: ${({ theme }) => theme || '#FFF'};
    border-radius: 5px;
    padding: 5px;
    overflow-x: auto; 
    overflow-y: hidden;
    max-width: 100%;
  }
  .code1 {
    font-size: 12px;
    display: block;
    text-align: left;
  }
  .singleBackTick {
    background-color: ${({ theme }) => theme || '#FFF'};
    font-size: 12px;
    display: inline;
    text-align: left;
    border-radius: 5px;
    padding: 5px;
  }
  @media only screen and (min-width: 768.01px) {
    .pre1 {
      width: auto;
      max-width: ${({isFullScreen}) => isFullScreen ? "800px" : "230px"} ;; 
    }
  }
  @media only screen and (max-width: 360px) {
    .pre1 {
      width: auto;
      max-width: 202px; 
    }
  }
    
`;


export default function TextContent({ linkColor, color, children = '', isFullScreen=false }) {
  const { theme, trackLinkClick } = useChat();

  const handleClick = (e) => {
    const anchor = e.target.closest('a');
    if (anchor) {
      trackLinkClick({ url: anchor.href, text: anchor.innerText });
    }
  };
  
  const formatText = (text) => {
    text = text.replace(regexForCodeblocks, (match, lang, code) => {
      code = code.replace(/[&<>]/g, (char) =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
        }[char])
      );
      return `<div class="div1"><pre class="pre1"><code class="code1 lang-${lang || 'text'}">${code}</code></pre></div>`;
    });
    text = text.replace(/`([^`]+)`/g, (match, code) => {
      return `<code class="singleBackTick">${code.trim()}</code>`;
    });
    // Replace headers with <h3> tags
    text = text.replace(/### (.+?)(?=\n|$)/g, '<h3>$1</h3>');

    // Replace list items with <li> tags inside a <ul>
    text = text.replace(/- (.+?)(?:\r?\n|$)/g, '<li style="list-style:disc;margin-left:18px;">$1</li>');
    text = text.replace(/(<li>.+<\/li>)/g, '<ul >$1</ul>');
    
    // Replace bold text with <strong> tags
    text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

    // Replace image with <img> tag
    text = text.replace(/!\[(.+?)\]\((.+?)\)/g, '<img alt="$1" src="$2" height="160" width="160" style="display:block; margin: 0 auto;padding-top:10px;"/>');

    // Replace links with <a> tags
    text = text.replace(/\[(.+?)\]\((.+?)\)/g, '<a href="$2" target="_blank">$1</a>');

    text = text.replace(/\n/g, '<br />') // Replace newlines with <br> tags
    .replace(/---/g, '<hr>');            // replace --- with horizontal line tag

    return text;
  };
  
  // console.log("message = ", children)
  // console.log("formattedText = ", formattedText)
  return (
     <Content
        isFullScreen={isFullScreen}
          linkColor={linkColor}
          color={color}
          theme={theme}
          onClick={handleClick}
          dangerouslySetInnerHTML={{
            __html: formatText(children)
         }}
      />
  );
}
